<template>
  <div>
    <v-tabs background-color="transparent" v-model="tab">
      <v-tab>Datos Generales</v-tab>
      <v-tab>Existencias</v-tab>
      <v-tab v-if="edit">Compras</v-tab>
      <v-tab v-if="edit">Recetas</v-tab>
    </v-tabs>
    <v-tabs-items class="px-4" v-model="tab">
      <v-tab-item light="false">
        <v-form ref="prodForm">
          <v-autocomplete
            disabled
            v-model="productoData.Tipo"
            :items="tiposProducto"
            label="Tipo de producto"
            @change="$forceUpdate()"
            :rules="rules.Tipo"
            item-value="id"
            item-text="name"
          >
          </v-autocomplete>
          <v-text-field
            v-model="productoData.Nombre"
            :rules="rules.Nombre"
            label="Nombre del Insumo"
          >
          </v-text-field>
          <v-autocomplete
            v-model="Extra.AYB.UM"
            :items="tiposUm"
            :rules="rules.Requerido"
            label="Unidad de medida"
          >
          </v-autocomplete>
          <v-autocomplete
            multiple
            v-model="productoData.Departamentos"
            :rules="rules.Departamento"
            label="Departamento"
            :items="modulos"
          >
          </v-autocomplete>
          <v-autocomplete
            v-model="productoData.Categoria"
            label="Categoría del insumo"
            :items="categoriesList"
            :rules="rules.Categoria"
            item-value="id"
            item-text="label"
          >
          </v-autocomplete>
          <v-text-field
            v-model="Extra.AYB.Mm"
            :rules="rules.Merma"
            @keypress="$pgsHelper.onlyNumber($event, Extra.AYB.Mm)"
            label="Merma (%)"
          >
          </v-text-field>
          <v-text-field
            v-if="!edit"
            v-model="productoData.Codigo"
            :rules="rules.Codigo"
            label="Codigo del insumo"
          />
          <v-text-field
            v-model="productoData.Alerta"
            @keypress="$pgsHelper.onlyNumber($event, productoData.Alerta)"
            label="Existencia mínima para alertar baja existencia"
          />
          <v-text-field
            v-if="false"
            v-model="productoData.Alerta"
            @keypress="$pgsHelper.onlyNumber($event, productoData.Alerta)"
            label="Existencia maxima"
          />
          <v-switch
            v-if="false"
            v-model="initInv"
            label="Configurar Inventario inicial"
          />
        </v-form>
      </v-tab-item>
      <v-tab-item>
        <v-alert
          border="top"
          colored-border
          type="info"
          elevation="1"
          class="mt-2"
        >
          <h4>Existencia óptima</h4>
          <b
            >Existencia óptima basa en tendencias de ventas de los últimos 60
            días : {{ $pgsHelper.formatNumber(productoData.eidl) }}
            {{ Extra.AYB.UM }}</b
          >
        </v-alert>
        <v-text-field
          v-model="productoData.fcmp"
          @keypress="$pgsHelper.onlyNumber($event, productoData.fcmp)"
          label="Plazo entre pedidos (días)"
        />
        <v-text-field
          v-model="productoData.ftlr"
          @keypress="$pgsHelper.onlyNumber($event, productoData.ftlr)"
          label="Días extra de tolerancia"
        />
        <v-divider class="mb-4"></v-divider>
        <h4>Agregar máximos y mínimos</h4>
        <p>Existencias deseadas para cada almacen</p>
        <v-form ref="exstForm">
          <v-row>
            <v-col md="3">
              <v-autocomplete
                v-model="almacenesForm.id"
                :items="Almacenes"
                :rules="rules.Requerido"
                item-value="id"
                item-text="Nombre"
                label="Almacen"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="3">
              <v-text-field
                v-model="almacenesForm.emin"
                @keypress="$pgsHelper.onlyNumber($event, almacenesForm.emin)"
                :label="'Existencia mínima ' + Extra.AYB.UM"
              />
            </v-col>
            <v-col md="3">
              <v-text-field
                v-model="almacenesForm.eidl"
                @keypress="$pgsHelper.onlyNumber($event, almacenesForm.eidl)"
                :label="'Existencia ideal ' + Extra.AYB.UM"
              />
            </v-col>
            <v-col md="3">
              <v-btn @click="addAlmacen" color="primary" block>Agregar</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-4"></v-divider>
        <h4>Máximos y minimos configurados:</h4>
        <template v-for="(amc, index) in almacenes">
          <v-row :key="index">
            <v-col md="3" class="ma-auto">
              <b>{{ getAlmacenById(index) }}</b>
            </v-col>
            <v-col md="3">
              <v-text-field
                v-model="amc.emin"
                @keypress="$pgsHelper.onlyNumber($event, amc.emin)"
                :label="'Existencia mínima ' + Extra.AYB.UM"
              />
            </v-col>
            <v-col md="3">
              <v-text-field
                v-model="amc.eidl"
                @keypress="$pgsHelper.onlyNumber($event, amc.eidl)"
                :label="'Existencia ideal ' + Extra.AYB.UM"
              />
            </v-col>
            <v-col md="3">
              <v-btn color="error" @click="deleteAlmacen(index)">X</v-btn>
            </v-col>
          </v-row>
        </template>
      </v-tab-item>
      <v-tab-item>
        <h4>Ultimas Compras</h4>
        <v-list dense>
          <template v-for="(compra, index) in compras">
            <v-list-item :key="index">
              <v-list-item-content>
                <v-row>
                  <v-col md="4" cols="12">
                    <v-list-item-title v-text="compra.dsc"></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="compra.id"
                    ></v-list-item-subtitle>
                    {{ compra.fecha }}
                  </v-col>
                  <v-col md="4" cols="12"
                    >${{ $pgsHelper.formatNumber(compra.Total) }} <br />
                    {{ compra.estatus }}</v-col
                  >
                  <v-col md="4" cols="12"
                    ><v-btn
                      outlined
                      color="primary"
                      @click="loadDetailCompra(compra.id)"
                      >Detalle</v-btn
                    ></v-col
                  >
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-tab-item>
      <v-tab-item>
        <h4>Uso en recetas</h4>
        <v-simple-table>
          <thead>
            <tr>
              <th>Receta</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(receta, index) in usoRecetas">
              <tr :key="index">
                <td>{{ receta.Nombre }}</td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-tab-item>
    </v-tabs-items>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)"> Cancelar </v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
    <modal
      v-model="showModal"
      :showFooter="false"
      :fullscreen="true"
      title="Compra"
    >
      <ComprasForm
        :edit="editMode"
        @toggle="toggleModal"
        :key="formIndex"
        :presentacionesAll="presentacionesAll"
        :presentaciones="presentaciones"
        :dataEdit="editData"
      />
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import Producto from "../../../clases/Producto.js";
import Currency from "../../../clases/Currencies.js";
import ComprasForm from "../../Inventarios/Compras/ComprasForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ProductosForm",
  components: { ComprasForm },
  props: ["edit", "dataEdit"],
  data() {
    return {
      formIndex: 0,
      tab: 0,
      productoData: new Producto(),
      initInv: false,
      Categories: [],
      errors: {},
      monedas: Currency.getCurrencies(),
      tiposProducto: Producto.getTiposProducto(),
      tiposUm: Producto.getTiposUm(),
      loader: true,
      rules: Producto.getRules(),
      compras: [],
      presentaciones: [],
      presentacionesAll: [],
      almacenesForm: {
        id: null,
        eidl: 0,
        emin: 0,
      },
      almacenes: {},
      Extra: {
        AYB: {
          UM: "",
          Rm: 0,
          Mm: "",
        },
      },
      showModal: false,
      editData: null,
      editMode: false,
    };
  },
  methods: {
    loadDetailCompra(id) {
      this.formIndex++;
      this.editMode = true;
      this.editData = this.$pgsHelper.getById(this.compras, "id", id);
      this.showModal = true;
    },
    deleteAlmacen(id) {
      delete this.almacenes[this.almacenesForm.id];
      this.$forceUpdate();
    },
    async getPresentaciones() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("AMC_Presentaciones", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      if (data.empty) {
        this.presentaciones = [];
        this.presentacionesAll = [];
      } else {
        let doc = data.docs.map((doc) => {
          return { Id: doc.ref.id, ...doc.data() };
        });
        let presentaciones = [];
        let presentacionesAll = [];
        doc.forEach((data) => {
          if (!data.Dlat) {
            presentaciones.push(data);
          }
          presentacionesAll.push(data);
        });
        this.presentaciones = presentaciones;
        this.presentacionesAll = presentacionesAll;
      }
    },
    toggleModal(open) {
      this.showModal = open;
    },
    getAlmacenById(id) {
      let exist = this.$pgsHelper.getById(this.Almacenes, "id", id);
      if (exist) {
        return exist.Nombre;
      } else {
        return "sin almacen";
      }
    },
    addAlmacen() {
      if (this.$refs.exstForm.validate()) {
        this.almacenes[this.almacenesForm.id] = {
          eidl: Number(this.almacenesForm.eidl),
          emin: Number(this.almacenesForm.emin),
        };
        this.$forceUpdate();
      }
    },
    checkForm: function (e) {
      if (this.$refs.prodForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          if (this.productoData.Tipo != "AYB-Insumo") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
          }
          doAction = "EDIT";
        } else {
          if (this.productoData.Tipo != "AYB-Insumo") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
          }
        }
        if (this.productoData.Precio == "") {
          this.productoData.Precio = 0;
          this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
        }
        this.productoData.Extra = this.Extra;
        this.productoData.Alerta = Number(this.productoData.Alerta);
        this.productoData.Extra.AYB.Mm = Number(this.productoData.Extra.AYB.Mm);
        for (const property in this.almacenes) {
          this.almacenes[property].eidl = Number(this.almacenes[property].eidl);
          this.almacenes[property].emin = Number(this.almacenes[property].emin);
        }
        this.productoData.amcs = this.almacenes;
        this.$emit("successData", this.productoData, doAction);
      }
    },
    async getCompras() {
      console.log("compras")
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let data = await firestore.queryBuilder("AMC_Compras", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("_idx", "array-contains", this.productoData.Id),
        firestore.where("sts", "==", "A"),
        firestore.orderBy("Crat", "desc"),
        firestore.limit(15),
      ]);
      let document = data.docs.map((doc) => {
        console.log(doc)
        return { id: doc.ref.id, ...doc.data() };
      });
      document.forEach((compra) => {
        compra.fecha = new moment(compra.mmt, "YYYY-MM-DD_HH:mm:ss").format(
          "YYYY-MM-DD HH:mm"
        );
        compra.estatus =
          compra.sts == "A"
            ? "Aplicado"
            : compra.sts == "C"
            ? "Cancelado"
            : "Pendiente";
        let total = 0;
        compra.adq.forEach((ins) => {
          total += Number(ins.pcu.C) * ins.cnt;
        });
        compra.Total = total;
      });
      this.compras = document;
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    usoRecetas() {
      let recetas = [];

      let prod = this.$store.getters.getProductos;
      prod.forEach((element) => {
        if (!element.Dlat) {
          if (element._CatIdx) {
            if (element._CatIdx.includes(this.productoData.Id)) {
              recetas.push(this.$pgsHelper.cloneObj(element));
            }
          }
        }
      });
      return recetas;
    },
    Almacenes() {
      return this.$store.getters.getCentrosConsumo;
    },
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    categoriesList() {
      let categories = [];
      if (this.productoData.Departamentos.length > 0) {
        this.Categories.forEach((categoria) => {
          this.productoData.Departamentos.forEach((modulo) => {
            if (modulo == categoria.Departamento) {
              categories.push(categoria);
            }
          });
        });
        return categories;
      } else {
        return this.Categories;
      }
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.Extra = {
      AYB: {
        UM: "",
        Rm: 0,
        Mm: "",
      },
    };
    this.getCategories();
    this.loader = false;
    if (this.edit) {
      this.productoData = new Producto(this.dataEdit);
      this.Extra.AYB.UM = this.productoData?.Extra?.AYB?.UM;
      this.Extra.AYB.Mm =
        this.productoData?.Extra?.AYB?.Mm !== undefined &&
        this.productoData?.Extra?.AYB?.Mm !== null
          ? this.productoData.Extra.AYB.Mm
          : "";
      this.almacenes = this.productoData?.amcs;
      this.getCompras();
      this.getPresentaciones();
    }
    this.productoData.Tipo = "AYB-Insumo";
  },
};
</script>
